import { css } from '@emotion/react';
import COLORS from 'shared/styles/colors';
import theme from 'shared/styles/themes';

export default css({
  '&.add-files-to-collection': {
    '& svg': {
      color: COLORS.NEUTRAL500,
    },
  },
  '.add-files-to-collection': {
    '&__btn': {
      whiteSpace: 'nowrap',
      minWidth: 'unset',
    },
    '&__submit-btn': {
      margin: `${theme.space[4]} 0`,
    },
  },
});
